const siteId = process.env.REACT_APP_BUILD_SITE;

const realEstateTypeFilterOptionsBySite = {
  '24MX': [1, 2, 3, 4, 5, 7, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 33, 34, 101],
  CAPA: [1, 2, 3, 4, 5, 6, 7, 8, 10, 25, 33, 34, 38, 44, 46, 47, 48, 49, 50],
  DVPE: [1, 2, 3, 4, 5, 22, 25, 26, 27, 28, 29, 34, 35, 40, 41, 42, 43, 100],
  UBPE: [1, 2, 3, 4, 5, 22, 25, 26, 27, 28, 29, 34, 35, 40, 41, 42, 43, 100],
  LLVE: [1, 2, 3, 4, 5, 6, 8, 25, 33, 34, 38, 41, 55, 99],
  PLEC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 25, 32, 33, 34],
  ZPAR: [1, 2, 4, 5, 7, 8, 10, 11, 14, 26, 32, 33, 34, 35, 38, 45, 99, 2000, 2001, 2005],
  ICBR: [1, 2, 33, 34, 35, 40, 41, 42, 43, 47, 48, 49, 50, 1003, 1004, 1005],
  IWBR: [1, 2, 33, 34, 35, 40, 41, 42, 43, 47, 48, 49, 50, 1003, 1004, 1005],
  WIBR: [1, 2, 33, 34, 35, 40, 41, 42, 43, 47, 48, 49, 50, 1003, 1004, 1005]
};

const filtersOptions = {
  statusFilterOptions: ['ONLINE', 'DRAFT', 'DELETED', 'OFFLINE', 'ON_HOLD', 'NEAR_END', 'WITHOUT_CREDIT'],
  operationTypeFilterOptions: ['1', '2', '4'],
  publicationPlanFilterOptions: ['0', '1', '2'],
  realEstateTypeFilterOptions: realEstateTypeFilterOptionsBySite[siteId]
};

const sitesWithTraspaso = ['24MX', 'DVPE', 'UBPE', 'CAPA'];
if (sitesWithTraspaso.includes(siteId)) {
  filtersOptions.operationTypeFilterOptions.push('3');
}

const sitesWithFreemium = ['ZPAR', '24MX', 'ICBR', 'WIBR', 'IWBR'];
if (sitesWithFreemium.includes(siteId)) {
  filtersOptions.publicationPlanFilterOptions.push('3');
}

export const {
  statusFilterOptions,
  operationTypeFilterOptions,
  publicationPlanFilterOptions,
  realEstateTypeFilterOptions
} = filtersOptions;

export const staticFilters = [
  {
    title: 'status',
    filters: statusFilterOptions
  },
  {
    title: 'operationType',
    filters: operationTypeFilterOptions
  },
  {
    title: 'publicationPlan',
    filters: publicationPlanFilterOptions
  },
  {
    title: 'realEstateType',
    filters: realEstateTypeFilterOptions
  }
];
